export default __webpack_public_path__ + "static/media/lacarefooterlogo.c7d7bcb2.png";